"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDndCjs = require("react-dnd-cjs");

var _helper = require("./helper");

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@react-page/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var instances = {};

var Draggable = function Draggable(_ref) {
  var connectDragPreview = _ref.connectDragPreview,
      connectDragSource = _ref.connectDragSource,
      isDragging = _ref.isDragging,
      children = _ref.children,
      className = _ref.className;
  (0, _react.useEffect)(function () {
    var img = new Image();

    img.onload = function () {
      return connectDragPreview(img);
    };

    img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAAA6UlEQVRYhe2ZQQ6CMBBFX0njHg7ESXTp1p3uvIBewc3Em3AfdelSFwRDCAm01JRO+pa0lP8zzc9kMCKyAa7AFqhIixdwB44WuACHuHq8KWm1vwtgF1lMCPaWkevUNE3Qr9R17XTu1P5uvUdV+IpbG2qMGBH5xBYRAjUVUWPEjj10SS3XRFry3kha/VBTETVGcmqtDTVGFqdWn7k9ku96f88QNRVRYySn1tpQY8QptXz7qinmnpt7rZTIqbU21BgJ2mv1+XfCDVFTETVGjIg8SG8KP+RZ0I7lU+dmgRNgaKfyZVw9znT/R85fOHJJE77U6UcAAAAASUVORK5CYII=';
  }, []);
  var classes = (0, _classnames["default"])(className, {
    'ory-toolbar-draggable-is-dragged': isDragging
  }, 'ory-toolbar-draggable');
  return connectDragSource( /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "drag-point",
    className: classes
  }, children));
};

var mapStateToProps = null;
var _Actions$Display = _core.Actions.Display,
    insertMode = _Actions$Display.insertMode,
    editMode = _Actions$Display.editMode,
    layoutMode = _Actions$Display.layoutMode;
var clearHover = _core.Actions.Cell.clearHover;
var mapDispatchToProps = {
  insertMode: insertMode,
  editMode: editMode,
  layoutMode: layoutMode,
  clearHover: clearHover
};

var _default = function _default() {
  var dragType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'CELL';

  if (!instances[dragType]) {
    instances[dragType] = (0, _core.connect)(mapStateToProps, mapDispatchToProps)((0, _reactDndCjs.DragSource)(dragType, _helper.source, _helper.collect)(Draggable));
  }

  return instances[dragType];
};

exports["default"] = _default;